import axiosInstance from './axiosInstance'

export const getUserById = (userId) => {
  return axiosInstance.get(`/users/${userId}`)
}

export const getUsers = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/users?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const getSalesUsers = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/users/sales?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const getUsersByRoles = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc', roles = [], active = false) => {
  return axiosInstance.get(`/users/byroles?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}&roles=${roles.join(',')}&active=${active}`)
}

export const createUser = (data) => {
  return axiosInstance.post('/users', data)
}

export const updateUser = (userId, data) => {
  return axiosInstance.put(`/users/${userId}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const toggleUserLock = (userId) => {
  return axiosInstance.put(`/users/${userId}/lock`)
}

export const deleteUser = (userId) => {
  return axiosInstance.delete(`/users/${userId}`)
}
